export default __webpack_public_path__ + "static/media/Jabira_Farhath.7d66c07e.jpg";